import React, { FC } from 'react';

import { Modal } from '../../components/modal/index';

export type DeleteConfirmModalProps = {
  description: string;
  isOpen: boolean;
  isPending: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
  title: string;
};

// Shared "are you sure?" guard so nothing is deleted by accident. Red confirm button (Modal default).
export const DeleteConfirmModal: FC<DeleteConfirmModalProps> = ({
  isOpen,
  isPending,
  title,
  description,
  onConfirm,
  onDismiss,
}) => (
  <Modal
    crossButton
    description={description}
    dismissButtonContent="Cancel"
    isOpen={isOpen}
    onDismiss={onDismiss}
    onHardClose={onDismiss}
    onSuccess={isPending ? undefined : onConfirm}
    successButtonContent={isPending ? 'Deleting…' : 'Delete'}
    title={title}
  />
);
